import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function LatestSection() {
  const latestMovies = movies.filter((m) => m.newRelease).slice(0, 8);

  return (
    <section className="py-12 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新热播电影电视剧每日更新</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {latestMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.slug}`}
              className="group flex gap-4 bg-background-50 rounded-xl p-3 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  title={`${movie.title} - 星空影院${movie.quality}高清在线观看`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col justify-between py-1 min-w-0">
                <div>
                  <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {movie.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-2 leading-relaxed">
                    {movie.description.slice(0, 60)}...
                  </p>
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
                  <span className="px-1.5 py-0.5 bg-accent-500/10 text-accent-500 rounded font-medium whitespace-nowrap">
                    {movie.quality}
                  </span>
                  <span>{movie.year}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}